@if (stage) {
  {{ stage }}
} @else {
  -
}
